<form class="f-col blank-form">
    <div class="section-heading">
        <h2 class="h2-heading">Booking queue management <div class="dot">.</div> <span class="optional">Optional</span></h2>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content">

        <div class="inner-contentsection" [formGroup]="addBookingQueueForm" >
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Select Event Type</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-slect">stat_minus_1</mat-icon>
                        <mat-select formControlName="eventType">
                            <mat-option>
                                Option 1
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Select Product Type</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-slect">stat_minus_1</mat-icon>
                        <mat-select formControlName="produtType">
                            <mat-option>
                                Option 1
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Select GDS</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-slect">stat_minus_1</mat-icon>
                        <mat-select formControlName="gds">
                            <mat-option>
                                Option 1
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Select Branch Name</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-slect">stat_minus_1</mat-icon>
                        <mat-select formControlName="branchName">
                            <mat-option>
                                Option 1
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>PCC</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Queue No.</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Sub Queue No.</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small">Cancel</button>
            <button mat-button class="button--primary-small">Save</button>
        </div>
    </div>
</form>
